import type * as AddToBasket from '@ori-events/add-to-basket';
import * as AddToBasketFailed from '@ori-events/add-to-basket-failed';
import * as ShowLoyaltyDialog from '@ori-events/show-loyalty-dialog';
import type { PositionData } from '@ori/analytics-data';
import { HttpMethod } from '@ori/checkout-utils';

import { logWarning } from '../logger';
import { convertToCamelCase } from './convertToCamelCase';
import { getHttpRequestSettings } from './getHttpRequestSettings';

export type AddToBasketParams = AddToBasket.Data &
  PositionData & {
    choiceId?: number | null;
    catalogueItemId?: string;
  };

export const MISSING_PLACEMENT_MESSAGE = `Missing 'placement' property in add-to-basket action data will impact reporting, please contact your SE.`;

export async function addToBasket(url: string, params: AddToBasketParams, buyingMethod: AddToBasket.Method) {
  const { itemCode, placement, quantity } = params;
  if (!placement) {
    logWarning(MISSING_PLACEMENT_MESSAGE);
  }
  const response = await fetch(url, getHttpRequestSettings(params, HttpMethod.Post));
  const data = convertToCamelCase<AddToBasketFailed.AddToBasketResponse>((await response.json()) as object);

  if (AddToBasketFailed.isAddToBasketErrorResponse(data)) {
    const event = new CustomEvent<AddToBasketFailed.Data>(AddToBasketFailed.Name, {
      detail: data,
    });
    window.dispatchEvent(event);

    return false;
  }

  if (AddToBasketFailed.isAddToBasketLoyaltyResponse(data)) {
    const event = new CustomEvent<ShowLoyaltyDialog.Data>(ShowLoyaltyDialog.Name, {
      detail: {
        ...data,
        itemCode,
        placement,
        quantity,
      },
    });
    window.dispatchEvent(event);

    return false;
  }

  return {
    ...data,
    lastAddedItem: {
      itemCode,
      method: buyingMethod,
      quantity,
    },
  };
}
